import * as React from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import { Modal, Space, Button } from "antd";
import { DeleteOutlined, EditOutlined, DownloadOutlined } from "@ant-design/icons";
import PageContent from "../../components/layout/PageContent";
import { getTableState } from "../../utils/localStorage";
import { getFormattedResponse } from "../../utils";
import CustomTable from "../../components/table/CustomTable";

const tablePrefix = 'config_gifts';

const Gifts = () => {

	const [data, setData] = React.useState([]);
	const [columns, setColumns] = React.useState([]);
	const [tableState, setTableState] = React.useState(() => {
		const {
			pageSize = 10,
			page = 1,
			loading = false,
			totalSize = 1
		} = getTableState(tablePrefix);
		return {
			pageSize,
			page,
			loading,
			totalSize,
		}
	});

	const confirm = Modal.confirm;

	React.useEffect(() => {
		const { page, pageSize } = tableState;
		fetchData({
			page,
			pageSize
		});
	}, []); // eslint-disable-line react-hooks/exhaustive-deps

	const fetchData = params => {
		setData([]);
		axios.post(
			"/api/gift-cards/list",
			params,
		)
			.then(({ data }) => {
				const {
					list,
					columns: cols,
					rest: { totalDocs = 1, limit = 20 } = {},
				} = getFormattedResponse(data);
				setColumns(cols);
				setData(list);
				setTableState((prevState) => {
					return {
						...prevState,
						totalSize: totalDocs,
						pageSize: limit,
						loading: false,
					}
				});
			})
			.catch((e) => {
				console.log(e);
			});
	};

	const handleInteraction = ({ page, pageSize, search, sort, order }) => {
		const params = {
			page,
			pageSize: pageSize,
			query: search,
			sort,
			order
		};
		setTableState({
			...tableState,
			page,
			pageSize,
			loading: true,
			sort,
			order
		});
		fetchData(params);
	};

	const downloadExel = async (id) => {
		const params = {
			giftCardId: id
		};

		axios.post('/api/gift-cards/export', params, {
			responseType: 'blob',
		}).then((response) => {
			const fileName = response?.headers?.['x-file-name'] ?? `${Date.now()}.tsv`;
			const url = window.URL.createObjectURL(new Blob(['\ufeff', response.data], { type: "text/tsv;charset=utf-8" }))
			const link = document.createElement('a');
			link.href = url;
			link.setAttribute('download', fileName);
			document.body.appendChild(link);
			link.click();
			link.remove();
		}).catch(err => console.log('Error>>>', err));
	}

	const deleteContent = id => {
		return new Promise((resolve, reject) => {
			axios.delete(`/api/gift-cards/${id}`)
				.then(({ data }) => {
					if (data.statusCode === 200) {
						fetchData(tableState);
					}
					resolve();
				})
				.catch(e => {
					reject();
					console.log(e);
				})
		})
	};

	const showConfirm = _id => {
		confirm({
			title: "Мэдээллийг устгах уу?",
			okText: "Устгах",
			cancelText: "Цуцлах",
			okType: 'danger',
			onOk() {
				deleteContent(_id);
			},
		});
	};

	const getColumns = () => {
		const formattedColumns = columns.map(col => {
			let render;
			if (col.key === "duration") {
				render = (text, record) => (
					`${text} cар`
				)
			}
			if (col.key === "name") {
				render = (text, record) => (
					<Link
						to={{
							pathname: "/giftcard/edit",
							state: {
								id: record._id,
							},
						}}
					>
						{text}
					</Link>
				);
			}
			return {
				...col,
				render
			}
		})

		const additionalColumns = [
			{
				key: "action",
				width: 1,
				sorter: false,
				fixed: 'right',
				render: (text, record) => (
					<Space size="middle" align="center">
						<DownloadOutlined onClick={() => downloadExel(record._id)} />
						<Link
							to={{
								pathname: '/giftcard/edit',
								state: {
									id: record._id
								},
							}}
						>
							<EditOutlined />
						</Link>
						<DeleteOutlined onClick={() => showConfirm(record._id)} />
					</Space>
				),
			},
		];

		return [
			...formattedColumns,
			...additionalColumns
		];
	};

	const getSubheaderContent = () => {
		return (
			<Link to={`/giftcard/add`}>
				<Button type='primary'>
					Шинэ бэлгийн карт үүсгэх
				</Button>
			</Link>
		)
	}

	return (
		<PageContent
			subheader={{
				title: 'Бэлгийн карт',
				background: '#ffffff',
				content: getSubheaderContent(),
			}}
		>
			<CustomTable
				bordered
				prefix={tablePrefix}
				dataSource={data}
				columns={getColumns()}
				rowKey='_id'
				showAll={false}
				onInteract={handleInteraction}
				state={tableState}
			/>
		</PageContent>
	)
};

export default Gifts;